/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BlogInputs */

const en_nav_blog = /** @type {(inputs: Nav_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing`)
};

const lv_nav_blog = /** @type {(inputs: Nav_BlogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raksti`)
};

/**
* | output |
* | --- |
* | "Writing" |
*
* @param {Nav_BlogInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_blog = /** @type {((inputs?: Nav_BlogInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BlogInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_blog(inputs)
	return en_nav_blog(inputs)
});